import React, { useEffect, useState } from 'react';
import { formatTimeAgo } from './time';

interface TimeAgoProps {
  timestamp: Date | string;
  className?: string;
  /** Refresh cadence in ms. Default 30s. */
  intervalMs?: number;
}

/** Self-updating relative timestamp. */
export default function TimeAgo({ timestamp, className = '', intervalMs = 30_000 }: TimeAgoProps) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  const iso = typeof timestamp === 'string' ? timestamp : timestamp.toISOString();
  return (
    <time dateTime={iso} className={`font-mono tabular-nums ${className}`}>
      {formatTimeAgo(timestamp)}
    </time>
  );
}
